import { permissions } from "@/utils/constants";
import usePermissions from "@/utils/hooks/usePermissions";
import { useSystem } from "@/utils/hooks/useLocation";

/**
 * Nusuk cards permissions for the active city system (Makkah vs Madinah).
 */
export function useNusukCardsPermissions() {
  const { currentSystem } = useSystem();
  const { hasAnyPermission } = usePermissions();
  const isMadina = currentSystem === "madina";

  return {
    canListBatches: hasAnyPermission([isMadina ? permissions.list_nusuk_cards_batchs_madina : permissions.list_nusuk_cards_batchs]),
    canViewBatch: hasAnyPermission([isMadina ? permissions.view_nusuk_cards_batchs_madina : permissions.view_nusuk_cards_batchs]),
    canCreateBatch: hasAnyPermission([isMadina ? permissions.create_nusuk_cards_batchs_madina : permissions.create_nusuk_cards_batchs]),
    canUpdateBatch: hasAnyPermission([isMadina ? permissions.update_nusuk_cards_batchs_madina : permissions.update_nusuk_cards_batchs]),
    canDeleteBatch: hasAnyPermission([isMadina ? permissions.delete_nusuk_cards_batchs_madina : permissions.delete_nusuk_cards_batchs]),
    canChangeDeliveryStatus: hasAnyPermission([isMadina ? permissions.change_delivery_status_nusuk_cards_batchs_madina : permissions.change_delivery_status_nusuk_cards_batchs]),
    canListReturns: hasAnyPermission([isMadina ? permissions.list_nusuk_cards_batch_returns_madina : permissions.list_nusuk_cards_batch_returns]),
    canCreateReturn: hasAnyPermission([isMadina ? permissions.create_nusuk_cards_batch_returns_madina : permissions.create_nusuk_cards_batch_returns]),
    canUpdateReturn: hasAnyPermission([isMadina ? permissions.update_nusuk_cards_batch_returns_madina : permissions.update_nusuk_cards_batch_returns]),
    canDeleteReturn: hasAnyPermission([isMadina ? permissions.delete_nusuk_cards_batch_returns_madina : permissions.delete_nusuk_cards_batch_returns]),
    canViewExportBatchReport: hasAnyPermission([isMadina ? permissions.view_export_nusuk_cards_batch_report_madina : permissions.view_export_nusuk_cards_batch_report]),
    canListIncidentReports: hasAnyPermission([isMadina ? permissions.list_nusuk_cards_batchs_incident_reports_madina : permissions.list_nusuk_cards_batchs_incident_reports]),
    canResolveIncidentReports: hasAnyPermission([isMadina ? permissions.resolve_nusuk_cards_batchs_incident_reports_madina : permissions.resolve_nusuk_cards_batchs_incident_reports]),
    /** Open batch details from list (list or view permission). */
    canOpenBatchDetails: hasAnyPermission([
      isMadina ? permissions.list_nusuk_cards_batchs_madina : permissions.list_nusuk_cards_batchs,
      isMadina ? permissions.view_nusuk_cards_batchs_madina : permissions.view_nusuk_cards_batchs,
    ]),
  };
}
